/* @flow */
import File, { MAX_IMAGE_PREVIEW_HEIGHT } from 'entities/File';
import Image from 'components/Image.jsx';
import ImageFilePreviewModal from 'components/ImageFilePreviewModal.jsx';
import Link from 'components/Link.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';
import React from 'react';
import Glyph from 'components/Glyph.jsx';
import cx from 'classnames';
import './styles/MessageItemImageAttachment.scss';

type Props = {
  file: File,
};

class MessageItemImageAttachment extends React.Component {
  props: Props;

  state = {
    loading: true,
  };

  // NOTE: This is a hack to prevent images from breaking the scrolled-to-bottom behavior of the
  // conversation view. This wouldn't be necessary if images were rendered with dimensions (need
  // dimensions from the backend). This causes a little bit of jank (a bit of a flash when the
  // image loads).
  handleImageOnLoad = () => {
    this.setState({ loading: false });
  };

  render() {
    const { file } = this.props;
    const urls = file.getUrls();

    let placeholder = null;
    if (this.state.loading) {
      const dimensions = file.getPreviewDimensions(MAX_IMAGE_PREVIEW_HEIGHT);
      const lineHeight = dimensions.height ? { lineHeight: `${dimensions.height}px` } : {};
      placeholder = (
        <Link
          style={{ ...dimensions, ...lineHeight }}
          className="MessageItemImageAttachment-icon"
          target="_blank"
          eventElementName="MessageItemImageAttachment-icon">
          <Glyph name="image" size="xxxlarge" solo />
        </Link>
      );
    }

    const modal = (<ImageFilePreviewModal file={file} />);

    return (
      <div
        className={cx({
          MessageItemImageAttachment: true,
          'MessageItemImageAttachment-loading': this.state.loading,
        })}>
        {placeholder}
        <ModalTrigger modal={modal}>
          <Link
            className="MessageItemImageAttachment-link"
            eventElementName="MessageItemImageAttachment-link">
            <Image
              className="MessageItemImageAttachment-image"
              style={{ maxHeight: MAX_IMAGE_PREVIEW_HEIGHT }}
              src={urls.cdn}
              onLoad={this.handleImageOnLoad}
            />
          </Link>
        </ModalTrigger>
      </div>
    );
  }
}

export default MessageItemImageAttachment;



// WEBPACK FOOTER //
// ./src/chat/components/MessageItemImageAttachment.jsx